import { Input, Select } from "antd";
import { useEffect, useState } from "react";
import { AiFillCloseCircle } from "react-icons/ai";
import PropTypes from "prop-types";

export const FormulaOperation = ({
  closeable = false,
  onClose = () => {},
  onChange = () => {},
  operation = { option: "", value: "" },
  parameters = [],
  disabled = false,
  width = "150px",
}) => {
  const [option, setOption] = useState("");
  const [value, setValue] = useState("");

  useEffect(() => {
    setOption(operation.option);
    setValue(operation.value);
  }, [operation]);

  const onChangeOption = (e) => {
    setOption(e.target.value);

    if (["time", "area", "year", "month"].includes(e.target.value)) {
      setValue(e.target.value);
      onChange({
        option: e.target.value,
        value: e.target.value,
        parameter: undefined,
        formula: undefined,
      });
    } else {
      setValue("");
      onChange({
        option: e.target.value,
        value: "",
        parameter: undefined,
        formula: undefined,
      });
    }
  };

  return (
    <div className="d-flex flex-column gap-2 " style={{ width, float: "left", position: "relative" }}>
      {closeable && (
        <AiFillCloseCircle style={{ position: "absolute", right: -5, top: -10, cursor: "pointer" }} onClick={onClose} />
      )}
      <select
        name="selectOne"
        id=""
        className="form-select"
        value={option}
        onChange={onChangeOption}
        style={{ boxShadow: "none" }}
        disabled={disabled}
      >
        <option>Select Type</option>
        <option value="parameter">Parameter</option>
        <option value="operator">Operator</option>
        <option value="time">Time</option>
        <option value="year">Year</option>
        {/* <option value="month">Month</option> */}
        <option value="area">Area</option>
        <option value="constant">Constant</option>
        <option value="text">Text</option>
      </select>

      <div style={{ width: "100%" }}>
        {(() => {
          switch (option) {
            case "parameter":
              return (
                <Select
                  size="large"
                  value={value || null}
                  onChange={(e, option) => {
                    setValue(e);
                    onChange({ value: e, parameter: option.id });
                  }}
                  style={{ boxShadow: "none", width: "100%" }}
                  disabled={disabled}
                  placeholder="Select Parameter"
                  //
                  showSearch={true}
                  filterOption={(input, option) =>
                    // eslint-disable-next-line no-unsafe-optional-chaining
                    (option?.children ? option?.children?.toLowerCase() : "").includes(input?.toLowerCase())
                  }
                >
                  {parameters?.length > 0 &&
                    parameters.map((item, index) => (
                      <option value={item.name} key={index} id={item._id}>
                        {item.name}
                      </option>
                    ))}
                </Select>
              );
            case "operator":
              return (
                <Select
                  value={value || null}
                  onChange={(e) => {
                    setValue(e);
                    onChange({ value: e });
                  }}
                  style={{ boxShadow: "none", width: "100%" }}
                  disabled={disabled}
                  placeholder="Select Operator"
                  size="large"
                >
                  <option value="+">+</option>
                  <option value="-">-</option>
                  <option value="x">x</option>
                  <option value="/">/</option>
                  <option value="(">(</option>
                  <option value=")">)</option>
                  <option value="=">=</option>
                </Select>
              );

            case "time":
            case "area":
            case "year":
            case "month":
              return (
                <Input
                  size="large"
                  type="text"
                  value={option}
                  className=" text-capitalize"
                  disabled
                  style={{ boxShadow: "none" }}
                />
              );
            default:
              return (
                <input
                  type="text"
                  name="value"
                  id="value"
                  value={value}
                  onChange={(e) => {
                    setValue(e.target.value);
                    onChange({ value: e.target.value });
                  }}
                  className="form-control"
                  placeholder="Enter a value"
                  style={{ boxShadow: "none" }}
                  disabled={disabled}
                />
              );
          }
        })()}
      </div>
    </div>
  );
};

FormulaOperation.propTypes = {
  closeable: PropTypes.bool,
  onClose: PropTypes.func,
  onChange: PropTypes.func,
  operation: PropTypes.object,
  parameters: PropTypes.array,
  disabled: PropTypes.bool,
  width: PropTypes.string,
};
